/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { IconMarketingBubbles } from '@amtrav/icons';

const MarketingBubblesGraphic = styled.div`
  width: 309px;
  height: 393px;
  position: absolute;
  left: 90px;
  z-index: 1;

  svg {
    width: 309px;
    height: 393px;
  }

  @media (max-width: 1280px) {
    left: 40px;
  }
`;

const MarketingBubbleMsg = styled.div`
  position: absolute;
  left: 82px;
  top: 113px;
  display: flex;
  align-items: center;
  width: 175px;
  height: 162px;
  font-size: 18px;
  color: white;
  text-align: center;
  line-height: 1.4;
  z-index: 2;
`;

const MarketingBubbles = ({ bubbleMessage }) => {
  return (
    <MarketingBubblesGraphic>
      <MarketingBubbleMsg>{bubbleMessage}</MarketingBubbleMsg>
      <IconMarketingBubbles />
    </MarketingBubblesGraphic>
  );
};

MarketingBubbles.propTypes = {
  bubbleMessage: PropTypes.string,
};

MarketingBubbles.defaultProps = {
  bubbleMessage: '',
};

export default MarketingBubbles;
